import React from "react";
import "../allcss/facility.css";
import { FaBus, FaFutbol, FaHome, FaChalkboardTeacher, FaBook, FaLaptop, FaBeer, FaUsers } from "react-icons/fa";

const facilities = [
  {
    title: "Morning Circle Time",
    icon: <FaUsers />,
    description:
      "Builds confidence, communication, and social skills through daily group interactions.",
    color: "#f44336",
    bgColor: "#ffece7",
    className: "bus-fac"
  },
  {
    title: "Activity-Based Learning",
    icon: <FaHome />,
    description:
      "Fun, hands-on activities encourage creativity, curiosity, and problem-solving.",
    color: "#388e3c",
    bgColor: "#b5d9c7",
    className: "playground-fac"
  },
  {
    title: "Creative Play Stations",
    icon: <FaChalkboardTeacher />,
    description:
      "Interactive play develops imagination, fine motor, and cognitive skills.",
    color: "#fbc02d",
    bgColor: "#ffecb3",
    className: "canteen-fac"
  },
  {
    title: "Outdoor Play Area",
    icon: <FaFutbol />,
    description:
      "Safe outdoor activities promote fitness, teamwork, and coordination.",
    color: "#00bcd4",
    bgColor: "#e0f7fa",
    className: "learning-fac"
  },
  {
    title: "Healthy Nutrition",
    icon: <FaBeer />,
    description:
      "Encourages healthy eating habits and overall well-being.",
    color: "#8e24aa",
    bgColor: "#f3e5f5",
    className: "library-fac"
  },
  {
    title: "Smart Learning Lab",
    icon: <FaLaptop />,
    description:
      "Interactive tools support creativity, exploration, and early learning.",
    color: "#00695c",
    bgColor: "#b2dfdb",
    className: "lab-fac"
  }
];

export default function Facility() {
  return (
    <section className="fac-sec">
      <h2 className="fac-title">World-Class Facilities for Young Learners</h2>
      <p className="fac-subtitle">
   Our thoughtfully designed learning spaces provide a safe, engaging, and child-friendly environment where children can explore, learn, and grow with confidence. Every facility supports creativity, curiosity, active play, and holistic development.
      </p>
      <br />
      <br />
      <div className="fac-container">
        {facilities.map((facility, index) => (
          <div
            key={index}
            className={`fac-card ${facility.className}`}
          >
            <div className={`fac-icon-wrap ${facility.className}`}>
              <div className="fac-icon">{facility.icon}</div>
            </div>
            <h3 className="fac-name" style={{ color: facility.color }}>
              {facility.title}
            </h3>
            <p className="fac-desc">{facility.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}